import React, { useState, useEffect } from 'react';
import Rotate90DegreesCcwIcon from '@mui/icons-material/Rotate90DegreesCcw';
import Rotate90DegreesCwIcon from '@mui/icons-material/Rotate90DegreesCw';

const ImageModal = ({ src, onClose }) => {
  const [rotation, setRotation] = useState(0);

  // Reset orientation whenever a different image is opened.
  useEffect(() => {
    setRotation(0);
  }, [src]);

  const rotate = (e, deg) => {
    e.stopPropagation(); // don't close the modal when using the controls
    setRotation((prev) => (prev + deg + 360) % 360);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <img
        src={src}
        alt="Zoomed"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxHeight: '80%',
          maxWidth: '80%',
          objectFit: 'contain',
          transform: `rotate(${rotation}deg)`,
          transition: 'transform 0.2s ease',
        }}
      />
      <div
        style={{ display: 'flex', gap: 12 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="btn btn-blue" onClick={(e) => rotate(e, -90)} title="หมุนทวนเข็ม 90°">
          <Rotate90DegreesCcwIcon />
        </button>
        <button className="btn btn-blue" onClick={(e) => rotate(e, 90)} title="หมุนตามเข็ม 90°">
          <Rotate90DegreesCwIcon />
        </button>
      </div>
    </div>
  );
};

export default ImageModal;
